import { render, staticRenderFns } from "./resources-popup.vue?vue&type=template&id=05caeeb6&scoped=true"
import script from "./resources-popup.vue?vue&type=script&lang=js"
export * from "./resources-popup.vue?vue&type=script&lang=js"
import style0 from "./resources-popup.vue?vue&type=style&index=0&id=05caeeb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05caeeb6",
  null
  
)

export default component.exports